import './What.scss';
import what from '../assets/imagen/we/we.jpg';
import whatWebp from '../assets/imagen/we/we.webp';
import ImageWebp from '../shared/image-webp/ImageWepb';

function What() {
  return (
    <div>
      <div className="what-box">
        <div className="what-info">
          <div className="mobile">
            <div className="title-what">
              <div>
                <hr className="line-what " />
              </div>
              <h1 className="what-title ">¿QUÉ HACEMOS? </h1>
            </div>
            <ImageWebp src={what} srcWebp={whatWebp} className="what-pic" />
          </div>
          <div>
            <h1 className="what-subt reveal">Cómo lo hacemos.</h1>
            <p className="what-text reveal">
              Nuestros clientes nos encargan trabajar en sus productos digitales, impulsando ideas
              desde el inicio hasta el lanzamiento. Como un equipo dinámico y con múltiples
              habilidades, podemos manejar cualquier desafío que se nos presente. Diseñamos y
              desarrollamos productos digitales y experiencias en línea que ayudan a nuestros
              clientes a crecer, innovar y transformarse. Escuchamos, aprendemos y entendemos antes
              de desarrollar. Identificamos sus objetivos juntos, luego usamos nuestra experiencia
              para encontrar ese punto óptimo de realismo e impacto. Ofrecemos un servicio completo
              que brinda investigación, estrategia, concepto, diseño, creación de prototipos,
              desarrollo, control de calidad y lanzamiento.
            </p>
            <p className="what-who reveal">WORK</p>
            <div className="line-home mobile">
              <hr className="line-menu" />
            </div>
          </div>

          <div className="desktop">
            <div className="title-what">
              <div>
                <hr className="line-we reveal" />
              </div>
              <h1 className="what-title reveal">¿QUÉ HACEMOS? </h1>
            </div>
            <ImageWebp src={what} srcWebp={whatWebp} className="what-pic" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default What;
